import type { Path } from "@/router";
import type { MetricCardType } from "@/components/MetricCard/MetricCard.types";
import MetricGrid from "@/components/MetricGrid";
import PlaceholderCard from "@/components/PlaceholderCard";
import SectionHeading from "@/components/SectionHeading";

import type { CareerPlanCompetencyScore } from "./careerPlanHistory";
import { getExperienceIndexGapCopy } from "./experienceIndexCompetencyCopy";
import { getExperienceIndexCompetencyIcon } from "./experienceIndexIcons";
import { getTopGaps, type CareerRoleFit } from "./experienceIndexResults";

const PRIORITY_GAPS_HEADING = {
  heading: "Priority Gaps",
  body: "Where this person has the most room to grow versus this comparison role."
};

const PRIORITY_GAPS_EMPTY_COPY = "No gaps versus this comparison role right now.";

export default function ExperienceIndexPriorityGapsSection({
  roleFit,
  scores,
  onSelectCompetency
}: {
  roleFit: CareerRoleFit;
  scores: CareerPlanCompetencyScore[];
  onSelectCompetency?: (competencyId: string) => void;
}) {
  const gaps = getTopGaps(roleFit, scores);
  const metrics: MetricCardType<Path>[] = gaps.map((gap) => ({
    iconName: getExperienceIndexCompetencyIcon(gap.competencyName),
    value: gap.competencyName,
    label: getExperienceIndexGapCopy(gap.competencyName),
    testId: `career-plan-priority-gap-${gap.competencyId}`,
    asButton: Boolean(onSelectCompetency),
    onClick: onSelectCompetency ? () => onSelectCompetency(gap.competencyId) : undefined
  }));

  return (
    <div className="[&>div:first-child]:pt-0" data-testid="career-plan-priority-gaps">
      <SectionHeading heading={PRIORITY_GAPS_HEADING.heading} body={PRIORITY_GAPS_HEADING.body} />
      {metrics.length > 0 ? (
        <MetricGrid metrics={metrics} layout="thirds" hasHeading />
      ) : (
        <PlaceholderCard title={PRIORITY_GAPS_EMPTY_COPY} iconName="quiz" testId="career-plan-priority-gaps-empty" />
      )}
    </div>
  );
}
